import React, { createContext, useContext, useEffect, useState } from 'react';
import authApi from '../services/authApi';
import { useAuth } from './AuthContext';

interface ChatBadgeCtx {
  unread: number;
  setUnread: (n: number) => void;
}

const ChatBadgeContext = createContext<ChatBadgeCtx>({ unread: 0, setUnread: () => {} });

export const ChatBadgeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!isAuthenticated) { setUnread(0); return; }
    authApi.getChatUnreadCount()
      .then(r => setUnread(r.data?.unreadCount ?? 0))
      .catch(() => {});
  }, [isAuthenticated]);

  return (
    <ChatBadgeContext.Provider value={{ unread, setUnread }}>
      {children}
    </ChatBadgeContext.Provider>
  );
};

export const useChatBadge = () => useContext(ChatBadgeContext);
